var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.0002C28 14.3336 28 12.6669 28 11.0002H23V12.3961C23.8958 12.3961 24.7986 12.3961 25.7014 12.3961C25.6111 12.4933 25.5625 12.5627 25.5 12.6252C23.2778 14.8544 21.0486 17.0836 18.8264 19.3127C18.2917 19.8544 17.7917 19.8544 17.25 19.3058C15.0347 17.0766 12.8264 14.8544 10.6181 12.6252C10.5625 12.5697 10.5139 12.5072 10.4167 12.3961C13.7986 12.3961 16.464 12.3958 19.8182 12.3958V11L9.38889 11.0002C8.63194 11.0002 8.01389 11.6113 8 12.3613C8 16.4516 8 20.535 8 24.6322C8.01389 25.3891 8.63194 26.0002 9.38889 26.0002H26.6111C27.3681 26.0002 27.9861 25.3891 28 24.6391C28 22.5905 28 21.2304 28 19.1818H26.5972C26.5972 20.8624 26.5972 21.8752 26.5972 23.5905C24.9097 21.8752 23.2708 20.2016 21.5972 18.5002C23.2778 16.8544 24.9306 15.2294 26.5972 13.5975C26.5972 14.3961 26.5972 15.1947 26.5972 16.0002H28ZM9.40972 13.5975C11.0556 15.1738 12.7569 16.7919 14.4792 18.4377C12.7639 20.1808 11.1111 21.8613 9.40972 23.5836C9.40972 20.1808 9.40972 16.8336 9.40972 13.5975ZM25.6111 24.6113C20.5139 24.6113 15.4931 24.6113 10.3819 24.6113C12.0833 22.8822 13.7361 21.2016 15.4375 19.4725C15.7431 19.785 16.0486 20.0905 16.3472 20.3961C17.2708 21.3405 18.7639 21.3544 19.7014 20.4169C19.9931 20.1252 20.2778 19.8336 20.5972 19.5072C22.2639 21.2016 23.9167 22.8822 25.6111 24.6113Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.35714,
    y1: 103,
    x2: 54.9566,
    y2: 93.3132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B66CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2591F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e08cbb0217da7a421bc660a7f84d921b.svg";
export { ForwardRef as ReactComponent };